var general_rtlignore_default = {
  "alignLeft": "g-9gD",
  "textWrapNowrap": "npapB",
  "alignRight": "yMdMS",
  "alignCenter": "peFtv",
  "sizeFullWidth": "_0Y9Ow",
  "renderedInTable": "vz29K",
  "sizeOriginal": "BzRgm",
  "sizeContent": "hxhTK",
  "sizeSmall": "sMYeI",
  "sizeSmallCenter": "nNyWl",
  "flex": "_1dtii"
};
export {
  general_rtlignore_default as default
};
//# sourceMappingURL=general.rtlignore-scss.js.map
